'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const AnchorBarListItemDescription = renderWithRef('AnchorBarListItem', null, (e, o)=>{
    let s = new Set([
        'swan-anchor-bar-list-item-description'
    ]), { children: n } = e;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: o,
        classNames: s,
        props: e,
        children: n
    });
});

export { AnchorBarListItemDescription };
